import Console from '@/shared/console';

const loadingOverlayModule = {
  namespaced: true,
  state: {
    counter: 0,
  },
  actions: {
    setIsLoading({ commit, state }, addLoading) {
      let count;
      if (addLoading) {
        count = state.counter + 1;
      } else {
        if (state.counter > 0) {
          count = state.counter - 1;
        } else {
          count = state.counter;
          Console.warn('Tried to remove loading when counter was 0');
        }
      }
      commit('updateCounter', count);
    },
  },

  mutations: {
    updateCounter(state, count) {
      state.counter = count ?? 0;
    },
  },

  getters: {
    getIsLoading(state) {
      return state.counter > 0;
    },
  },
};
export default loadingOverlayModule;
